<template>
  <div
    id="optOutMain"
    :class="['mobile', 'tablet'].includes($mq) ? 'mobileMode' : 'deskMode'"
  >
    <el-row
      type="flex"
      class="logoWrap"
      :class="`${$mq}Mode`"
    >
      <el-col
        class="logoCol"
        :span="responsiveCol"
      >
        <div class="logo">
          <img
            src="@/assets/logo/gcg_logo.png"
            alt="logo"
          />
        </div>
      </el-col>

      <el-col
        v-if="$mq !== 'mobile'"
        class="sloganCol"
        :span="responsiveCol"
      >
        <div class="slogan">
          <img
            src="@/assets/logo/gcg_slogan.png"
            alt="logo"
          />
        </div>
      </el-col>
    </el-row>

    <optOutSurvey
      v-if="user.supporter && !isSubmitted && !error"
      :user.sync="user"
      class="optOutCard"
      @submitSuccess="isSubmitted = true"
      @submitError="setError"
    />

    <optOutError
      v-else-if="error"
      :error-text="errorText"
      class="optOutCard"
    />

    <optOutSubmitted
      v-else-if="isSubmitted"
      class="optOutCard"
    />

    <div class="invisibleFooter"></div>
  </div>
</template>

<script>
import api from '@/api';
import optOutSurvey from './OptOutSurvey.vue';
import optOutSubmitted from './OptOutSubmitted.vue';
import optOutError from './OptOutError.vue';

export default {
  components: {
    optOutSurvey,
    optOutSubmitted,
    optOutError,
  },

  data() {
    return {
      isSubmitted: false,
      error: false,
      errorText: this.$t('coworker.errorOccurred'),
      user: {
        leader: '',
        supporter: '',
      },
    };
  },

  computed: {
    responsiveCol() {
      let col = 12;
      if (this.$mq === 'mobile') {
        col = 24;
      }
      return col;
    },
  },

  created() {
    this.fetchLeaderData();
  },

  methods: {
    async fetchLeaderData() {
      try {
        const response = await api.getOptSupporter(this.$route.params.id);
        this.user = response.data;
        this.isSubmitted = false; // TODO: remove, error handle by http code
      } catch (err) {
        this.error = true;
        if (err.msg) {
          this.errorText = err.msg;
        }
      }
    },

    setError(errMsg) {
      this.error = true;
      if (errMsg) {
        this.errorText = errMsg;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#optOutMain {
  position: absolute;
  width: 100%;
  min-width: 320px;
  min-height: 100vh;
  background: #2c567d;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .logoWrap {
    width: 100%;
    padding: 45px 5% 10px;
    display: block !important;

    .logoCol {
      .logo {
        img {
          width: 110px;
        }
      }
    }

    .sloganCol {
      text-align: right;

      .slogan {
        img {
          width: 180px;
        }
      }
    }

    &.mobileMode {
      padding: 30px 0;

      .logoCol {
        text-align: center;

        .logo {
          img {
            width: 100px !important;
          }
        }
      }
    }

    &.tabletMode {
      padding: 40px 5%;

      .logoCol {
        .logo {
          img {
            width: 100px !important;
          }
        }
      }

      .sloganCol {
        .slogan {
          img {
            width: 170px !important;
          }
        }
      }
    }
  }

  .optOutCard {
    margin: 0 auto;
  }

  &.mobileMode {
    height: unset;
    min-height: 100vh;
  }

  .invisibleFooter {
    width: 100%;
    padding: 50px 0;
  }
}
</style>
